import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { SxProps, Theme } from "@mui/material/styles";
import { FC, memo } from "react";
import { Control, Controller, FieldError } from "react-hook-form";

interface IMuiFormRadioGroup {
  name: string;
  label: string;
  error?: FieldError;
  control: Control<any>;
  items: Array<{ label: string; value: string }>;
  defaultValue?: string;
}

const styles: Record<string, SxProps<Theme>> = {
  formControl: {
    width: "100%",
    minWidth: "auto",

    "& .MuiTypography-root": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: "#25282D",
    },

    "& .MuiFormGroup-root": {
      flexWrap: "nowrap",
      marginLeft: "8px",
    },

    "& .MuiRadio-root": {
      p: "4px"
    }
  }
};

const MuiFormRadioGroup: FC<IMuiFormRadioGroup> = ({
  label,
  name,
  error,
  control,
  items,
  defaultValue,
}) => {
  return (
    <FormControl error={Boolean(error?.message)} sx={styles.formControl}>
      <Controller
        render={({ field }) => (
          <Stack direction="row" alignItems="center" gap="8px">
            <Typography>{label}</Typography>
            <RadioGroup row {...field} defaultValue={defaultValue}>
              {items.map((item) => (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  control={<Radio />}
                  label={item.label}
                />
              ))}
            </RadioGroup>
          </Stack>
        )}
        name={name}
        control={control}
      />

      {error?.message && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
};

export default memo(MuiFormRadioGroup);
